import { Trans } from 'react-i18next';

import { AlignedText } from '@actual-app/components/aligned-text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';
import type { AccountEntity } from '@actual-app/core/types/models';

import { Link } from '#components/common/Link';

import { calculatePortfolio } from './accountPortfolio';
import type { AccountBalances } from './accountPortfolio';
import { PortfolioAmount } from './PortfolioAmount';

type PortfolioSummaryProps = {
  accounts: readonly AccountEntity[];
  balances: AccountBalances;
};

export function PortfolioSummary({
  accounts,
  balances,
}: PortfolioSummaryProps) {
  const totals = calculatePortfolio(accounts, balances);
  return (
    <View
      data-testid="sidebar-portfolio-summary"
      style={{
        margin: '12px 14px 8px',
        flexShrink: 0,
        paddingBottom: 10,
        gap: 8,
        color: theme.sidebarItemText,
        borderBottom: `1px solid ${theme.sidebarItemBackgroundHover}`,
        fontSize: 12,
      }}
    >
      <AlignedText
        left={<Trans>총자산</Trans>}
        right={
          <PortfolioAmount
            value={totals?.assets ?? null}
            testId="sidebar-total-assets"
          />
        }
      />
      <AlignedText
        left={<Trans>총부채</Trans>}
        right={
          <PortfolioAmount
            value={totals?.liabilities ?? null}
            testId="sidebar-total-liabilities"
          />
        }
      />
      <Link
        variant="internal"
        to="/accounts"
        isExactPathMatch
        style={{
          color: theme.sidebarItemText,
          textDecoration: 'none',
          ':hover': { backgroundColor: theme.sidebarItemBackgroundHover },
        }}
      >
        <AlignedText
          style={{ fontWeight: 700, paddingTop: 3 }}
          left={<Trans>순자산</Trans>}
          right={
            <PortfolioAmount
              value={totals?.netWorth ?? null}
              testId="sidebar-net-worth"
            />
          }
        />
      </Link>
    </View>
  );
}
